import Resource from '@/api/resource';
import request from '@/utils/request';

/**
 * Zapytania kupujących „Szukam nieruchomości" (`property_requests`).
 *
 * OSOBNY zasób od `OfferResource` z premedytacją: to nie są oferty, więc nie
 * wolno im podstawiać akcji ofertowych (zmiana statusu po slugu, pakiety,
 * płatności). Backend wystawia tylko trzy trasy - listę, podgląd i decyzję
 * moderacji - i tyle ma ta klasa.
 */
class PropertyRequestResource extends Resource {
  constructor() {
    super('admin/property-requests');
  }

  /**
   * Decyzja admina: `approved` albo `rejected` (z powodem - bez niego backend
   * zwraca 422, bo powód trafia do maila i do panelu kupującego).
   * `pending` NIE jest decyzją - do moderacji cofa zapytanie wyłącznie edycja
   * treści przez właściciela.
   */
  moderate(id, moderationStatus, rejectionReason) {
    return request({
      url: '/' + this.uri + '/' + id + '/moderation',
      method: 'patch',
      data: {
        moderation_status: moderationStatus,
        rejection_reason: rejectionReason,
      },
    });
  }

  /**
   * Licznik oczekujących na moderację. `per_page=1`, bo z odpowiedzi
   * interesuje nas wyłącznie `meta.total` - ciągnięcie całej strony tylko po
   * liczbę byłoby marnotrawstwem przy każdym wejściu na ekran.
   */
  pendingCount() {
    return request({
      url: '/' + this.uri,
      method: 'get',
      params: { moderation_status: 'pending', per_page: 1 },
    });
  }
}

export { PropertyRequestResource as default };
